import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Realmente funciona si mi hijo es muy difícil?',
  a: 'Sí, porque el método no depende del comportamiento de tu hijo, sino de tu respuesta biológica al caos. Tú retomas el control.'
}, {
  q: '¿Es muy largo de leer?',
  a: 'No. Está diseñado para madres sin tiempo. Es directo, práctico y puedes empezar a aplicarlo hoy mismo.'
}, {
  q: '¿Qué pasa si ya he gritado demasiado?',
  a: 'Nunca es tarde para reparar. El sistema incluye una guía de reparación para sanar el vínculo con tus hijos.'
}, {
  q: '¿El pago es seguro?',
  a: 'Sí, utilizamos plataformas con encriptación de seguridad bancaria para proteger tu compra.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-12">
      <div className="text-center mb-12" data-id="element-13">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-4" data-id="element-14">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-15">
        {faqs.map((faq, index) => <div key={index} className="border border-border rounded-2xl overflow-hidden bg-cream/50" data-id="element-16">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-17">
              <span className="font-serif text-lg md:text-xl font-medium text-charcoal pr-4" data-id="element-18">
                {faq.q}
              </span>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="text-terracotta shrink-0" data-id="element-19">
                <ChevronDown size={24} data-id="element-20" />
              </motion.div>
            </button>
            <AnimatePresence data-id="element-21">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-22">
                  <div className="p-6 pt-0 text-charcoal/70 text-lg leading-relaxed border-t border-border/50 mt-2" data-id="element-23">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};